import { call, delay, put } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import {
  centrifugePublication,
  centrifugeSubscribeFailed,
  centrifugeSubscribeSuccessful,
} from '../actions';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import { refreshKeyCloak } from '../../Authorized/actions';

export default function* centrifugeSubscribe(action) {
  const {
    channel_id, token, type, module, channel_name,
  } = action.payload;
  if (!channel_id || !token) {
    return;
  }
  const { dispatch } = window.appStore;
  try {
    const subscription = window.centrifugeConnection.newSubscription(channel_name, {
      token,
      positioned: true,
      recoverable: true,
    });

    subscription.on('publication', ctx => {
      dispatch(centrifugePublication({ module, type })(ctx?.data));
    });

    // subscription.on('subscribed', ctx => {
    // console.error(`Подписан на канал: ${channel}`);
    // });

    subscription.on('error', ctx => {
      window.console.error(`Ошибка канала ${channel_id}: ${ctx.message}`);
    });

    subscription.subscribe();
    window.centrifugeSubscriptions.push(subscription);
    yield call(resolveActionPromise(action));
  } catch (e) {
    yield put(centrifugeSubscribeFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
